

export const selectedCallCode = state => state.selectedCallCode


// WEBPACK FOOTER //
// ./src/store/modules/callcodes/getters.js